module.exports = __webpack_public_path__ + "img/map1.ac8fbdd2.png";